import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=95285244&scoped=true&"
import script from "./AddLocation.vue?vue&type=script&lang=ts&"
export * from "./AddLocation.vue?vue&type=script&lang=ts&"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=95285244&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95285244",
  null
  
)

export default component.exports